import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, Chip, Typography } from "@mui/material";
import { isEqual } from "lodash";
import { useState } from "react";
import { MapComponent } from "../../../common/Maps";
import { SearcherAddressPredictiveComponent } from "../../../common/SearcherAddressPredictiveComponent";
import { colors } from "../../../ui/colors";
import { SASButtonStyles } from "../../../ui/styles/inputStyles";

export const StepWorkforceCoverage = ({ onNext, onBack, data: { coverageAreas } }) => {
  const [areas, setAreas] = useState(coverageAreas || []);
  const [focusArea, setFocusArea] = useState(null);
  const [coverageAreaSearch, setCoverageAreaSearch] = useState("");

  const handleNext = () => {
    onNext({ coverageAreas: areas });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: colors.gray[800],
          mb: 2,
        }}
      >
        Define Coverage Areas
      </Typography>

      {/* Search input */}
      <SearcherAddressPredictiveComponent
        store={coverageAreaSearch}
        storeAction={setCoverageAreaSearch}
        onSelectStore={areas}
        onSelectStoreAction={setAreas}
        label="Search or type a full address"
        onSelectedLocation={setFocusArea}
      />

      {/* Map */}
      <MapComponent
        width="100%"
        height={420}
        setLocalStore={setAreas}
        store={areas}
        focusStore={focusArea}
        disableLoadScript={true}
        sx={{
          borderRadius: 2,
          overflow: "hidden",
          border: `1px solid ${colors.orange[100]}`,
        }}
      />

      {/* Area Chips */}
      <Box
        sx={{
          mt: 2,
          display: "flex",
          flexWrap: "wrap",
          p: 1,
          gap: 1,
        }}
      >
        {areas.map((area, idx) => (
          <Chip
            key={idx}
            label={area.address}
            onClick={() => setFocusArea(area)}
            onDelete={() => setAreas((prev) => prev.filter((_, i) => i !== idx))}
            deleteIcon={<DeleteIcon sx={{ color: colors.orange[400], "&:hover": { color: colors.orange[600] } }} />}
            sx={{
              borderRadius: 2,
              fontSize: "0.85rem",
              fontWeight: 500,
              bgcolor: isEqual(focusArea, area) ? colors.orange[50] : "var(--fx-surface-base, #FFFFFF)",
              border: `1px solid ${isEqual(focusArea, area) ? colors.orange[400] : colors.gray[200]}`,
              boxShadow: isEqual(focusArea, area) ? "0 2px 6px rgba(255, 152, 0, 0.3)" : "0 1px 3px rgba(0,0,0,0.08)",
              "&:hover": {
                bgcolor: colors.orange[100],
                borderColor: colors.orange[400],
                transform: "translateY(-1px)",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              },
            }}
          />
        ))}
      </Box>

      {/* Buttons */}
      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, justifySelf: "flex-end", mt: 3 }}>
        <Button
          onClick={onBack}
          variant="outlined"
          sx={{
            borderRadius: "8px",
            px: 4,
            fontWeight: 600,
            fontSize: "0.9rem",
            color: colors.gray[600],
            borderColor: colors.gray[300],
            textTransform: "uppercase",
            "&:hover": { borderColor: colors.gray[400], bgcolor: colors.gray[100] },
          }}
        >
          Back
        </Button>

        <Button
          disabled={areas.length === 0}
          onClick={handleNext}
          sx={{
            ...SASButtonStyles,
            px: 5,
          }}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
};
